import React from "react";
import { useSelector } from "react-redux";

import { FavoriteList } from "@interface/entities/favorites";
import StoreInterface from "@interface/store/index";

import FavoriteCard from "./FavoriteCard";

const Favorites: React.FC = () => {
  const favoriteList = useSelector<StoreInterface, FavoriteList[]>(
    (state) => state.Favorites.data
  );
  const partnerList = favoriteList.filter(
    (item) => item.favoriteType === "partner"
  );
  const companyList = favoriteList.filter(
    (item) => item.favoriteType !== "partner"
  );

  partnerList.sort((itemA, itemB) => itemB.id - itemA.id);
  companyList.sort((itemA, itemB) => itemB.id - itemA.id);

  const renderFavoriteList = (list: FavoriteList[]) => {
    return list.map((item: FavoriteList) => {
      return (
        <FavoriteCard
          company={item.company}
          companyImage={item.companyImage}
          favoriteType={item.favoriteType}
          id={item.id}
          image={item.image}
          key={item.id}
          name={item.name}
          position={item.position}
          title={item.title}
        />
      );
    });
  };

  return (
    <div className="netw__favorites">
      {companyList.length > 0 ? (
        <div className="netw__group">
          <div className="netw__group-header">Компании</div>
          <div className="netw__favorites-body">
            {renderFavoriteList(companyList)}
          </div>
        </div>
      ) : null}
      {partnerList.length > 0 ? (
        <div className="netw__group">
          <div className="netw__group-header">Партнеры</div>
          <div className="netw__favorites-body">
            {renderFavoriteList(partnerList)}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Favorites;
